
import { Scanner } from 'src/app/model/scanner';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/services/menu.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { UserService } from 'src/app/services/user.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';

@Component({
  selector: 'app-scanner-search',
  templateUrl: './scanner-search.component.html',
})
export class ScannerSearchComponent implements OnInit {

  loading: boolean;
  loadingAction: boolean;
  scanners: Scanner[] = [];
  searchFilters: SearchFilter[];
  displayedColumns: string[] = ['Name', 'Star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(public dialog: MatDialog
    , private router: Router
    , private userService: UserService
    , private menuService: MenuService
    , private confirmDialogService: ConfirmDialogService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Escaner', 'Búsqueda');
  }

  ngOnInit(): void {

  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<Scanner>) {
    this.scanners = response.items;
    this.searchFilters = response.searchFilters;
    this.pager.setItems(this.scanners);
  }

  onStartSearch() {
    this.loading = true;
  }

  new(): void {
    this.router.navigate(['scanner-edit']);
  }

  edit(scanner: Scanner): void {
    this.router.navigate(['scanner-edit', scanner.Id]);
  }

  delete(scanner: Scanner): void {
    this.confirmDialogService.confirm('Escaner', 'Está seguro que desea elimnar el escaner?'
    , 'Sí', 'No').subscribe(async (value) => {
      if (value) {
        try {
          this.loadingAction = true;
          await this.userService.scannerDelete(scanner);
          await this.searchFilter.search();
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err.error), 'Escaner');
        } finally {
          this.loadingAction = false;
        }
      }
    });
  }
}
